module.exports = __webpack_public_path__ + "img/code-app.a1b0ea5.png";